import React from "react";

interface FieldProps {
    label: string;
    htmlFor: string;
    error?: string | null;
    children: React.ReactNode;
}

const Field: React.FC<FieldProps> = ({ label, htmlFor, error, children }) => {
    return (
        <div className="ui-field">
            <label className="ui-label" htmlFor={htmlFor}>
                {label}
            </label>
            {children}
            {error ? <span className="ui-error-text">{error}</span> : null}
        </div>
    );
};

export default Field;
